import { Star } from "lucide-react";
import { site } from "@/data/store";
import { getProduct } from "@/lib/store-helpers";

const Stars = ({ rating }) => (
  <div className="flex gap-1" aria-label={`${rating} out of 5 stars`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} className={`h-3.5 w-3.5 ${n <= rating ? "fill-black text-black" : "text-black/25"}`} strokeWidth={1.25} />
    ))}
  </div>
);

const BeforeAfter = ({ t }) => (
  <div className="grid grid-cols-2 gap-px bg-black/10">
    {[["Before", t.beforeImage], ["After", t.afterImage]].map(([label, src]) => (
      <figure key={label} className="relative bg-[#EFECE6]">
        <img src={src} alt={`${t.name} — ${label}`} loading="lazy" className="aspect-[3/4] w-full object-cover" />
        <figcaption className="absolute left-2 top-2 bg-[#F7F5F1] px-2 py-1 text-[10px] font-medium uppercase tracking-[0.16em]">{label}</figcaption>
      </figure>
    ))}
  </div>
);

const TestimonialCard = ({ t, index }) => {
  const product = getProduct(t.productSlug);
  return (
    <article data-testid={`testimonial-${index}`} className="flex flex-col border border-black/10 bg-white">
      {t.beforeImage && t.afterImage && <BeforeAfter t={t} />}
      <div className="flex flex-1 flex-col gap-5 p-6 sm:p-8">
        <div className="flex items-center justify-between gap-4">
          <Stars rating={t.rating} />
          {product && <span className="text-[10px] uppercase tracking-[0.18em] text-black/50">{product.name}</span>}
        </div>
        <blockquote className="font-serif text-2xl font-light leading-snug">“{t.quote}”</blockquote>
        <p className="mt-auto text-xs uppercase tracking-[0.16em] text-black/60">{t.name}</p>
      </div>
    </article>
  );
};

export const Testimonials = ({ productSlug, title = "Kind words" }) => {
  const items = productSlug ? site.testimonials.filter((t) => t.productSlug === productSlug) : site.testimonials;
  if (!items.length) return null;
  return (
    <section data-testid="testimonials-section" className="border-t border-black/10 bg-white/40">
      <div className="mx-auto max-w-[1440px] px-5 py-20 sm:px-8 lg:px-12 lg:py-28">
        <p className="text-[11px] font-medium uppercase tracking-[0.24em] text-black/50">{title}</p>
        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {items.map((t, i) => (
            <TestimonialCard key={i} t={t} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
